import { __assign, __extends } from "tslib";
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';
import { DEFAULT_TOOLTIP_OPTIONS } from './constants';

var TinyLine =
/** @class */
function (_super) {
  __extends(TinyLine, _super);

  function TinyLine() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型 */


    _this.type = 'tiny-line';
    return _this;
  }

  TinyLine.prototype.getDefaultOptions = function () {
    return {
      appendPadding: 2,
      tooltip: __assign({}, DEFAULT_TOOLTIP_OPTIONS)
    };
  };
  /**
   * 获取 迷你折线图 的适配器
   */


  TinyLine.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };

  return TinyLine;
}(Plot);

export { TinyLine };